import { useEffect } from "react";
import type { PanelEntry } from "../lib/api";
import { readLastWorkspace } from "../lib/lastWorkspace";
import { agentLanding, workspaceEntries, workspaceHref, workspaceTitle } from "../lib/workspaces";
import { LoadingState } from "../shell/ui";
import "./AgentHome.css";

/** The host owns this location; the current registration owns its content. */
export function overviewEntries(panels: PanelEntry[]) {
  return workspaceEntries(panels.filter(panel => panel.slot === "main" && panel.audience === "owner"))
    .filter(panel => panel.overview === true);
}

export function AgentHome({ panels, agentName = "创作助手", sessionId, onGo,
  onFocusConversation, seatKnown = true, active = true }: {
  panels: PanelEntry[]; agentName?: string; sessionId: string;
  onGo: (hash: string, replace?: boolean) => void; onFocusConversation?: () => void;
  seatKnown?: boolean; active?: boolean;
}) {
  const actions = workspaceEntries(panels.filter(panel => panel.slot === "main" && panel.audience === "owner" && !panel.interaction));
  const destination = (panel: PanelEntry) => workspaceHref(panel, sessionId);
  const landing = agentLanding(panels, readLastWorkspace());
  const single = landing ? destination(landing) : null;
  useEffect(() => { if (single && seatKnown && active) onGo(single, true); }, [single, seatKnown, active, onGo]);
  if (single) return <LoadingState label="正在打开工作区" />;
  return <section className="agent-home" data-testid="agent-home">
    <header className="agent-home-heading"><h1 className="own-title" tabIndex={-1}>{agentName}</h1></header>
      <div className="agent-home-empty">
        <h2>{actions.length ? "选一个界面" : "从你想完成的事开始"}</h2>
        {!actions.length ? <p>把想法或材料交给 {agentName}，一起开始。</p> : null}
        {actions.length ? <div className="agent-home-actions" aria-label="可用界面">
          {actions.map(panel => <button className="btn" type="button" key={panel.key}
            disabled={!seatKnown} onClick={() => onGo(destination(panel))}>{workspaceTitle(panel)}</button>)}
        </div> : null}
        <button className="btn" type="button" onClick={onFocusConversation}>开始对话</button>
      </div>
  </section>;
}
